<div>
    <h2>{{$data.title}}分支机构</h2>
    <table class="org-table">
        <colgroup>
            <col width="8%">     
            <col> 
            <col width="20%"> 
            <col width="20%">
        </colgroup> 
        <thead>
            <tr>
                <th>序号</th>
                <th>分支机构名称</th>
                <th>分支机构类型</th>
                <th>设立时间</th>
            </tr>
        </thead>
        <tbody class="_branchBody">
            
        </tbody>
    </table>
    <div class="page">
        <div id="_unitPage" class="l-pages pagination"></div>
    </div>
</div>